import { render, staticRenderFns } from "./MonitorPlayer.vue?vue&type=template&id=60d676f4&scoped=true"
import script from "./MonitorPlayer.vue?vue&type=script&lang=js"
export * from "./MonitorPlayer.vue?vue&type=script&lang=js"
import style0 from "./MonitorPlayer.vue?vue&type=style&index=0&id=60d676f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d676f4",
  null
  
)

export default component.exports